import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <>
      <footer className='footer-bg'>
        <Container>
          <div className='footer-text-between'>
            {/* <div>
                            <img src='images/gna-white-logo.png' alt='GNA Logo' />
                           
                        </div> */}
            <small >© {year}, GNA Energy Private Limited | All Rights Reserved.</small>
          </div>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
